import Vue from 'vue'

const state = {
    exchangeRate: {}
};

const getters = {
    exchangeRate: state => {
        return state.exchangeRate
    }
};

const mutations = {
    /**
     * Set exchange rate in store
     * @param state
     * @param data
     */
    setExchangeRate (state, data) {
        Vue.set(state, 'exchangeRate', data);
    }
};

const actions = {
    /**
     * Load exchange rate from api
     * @param commit
     * @returns {Promise.<void>}
     */
    async loadExchangeRate ( { commit } ) {
        let data = {
            usd: {
                label: 'USD',
                value: 2345
            },
            pln: {
                label: 'PLN',
                value: 412
            },
            eur: {
                label: 'EURO',
                value: 734
            },
            cny: {
                label: 'CNY',
                value: 361
            },
        };
        commit('setExchangeRate', data);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/exchange.js